import { render, staticRenderFns } from "./ExpensesList.vue?vue&type=template&id=b8aafd90&scoped=true"
import script from "./ExpensesList.vue?vue&type=script&lang=ts"
export * from "./ExpensesList.vue?vue&type=script&lang=ts"
import style0 from "./ExpensesList.vue?vue&type=style&index=0&id=b8aafd90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8aafd90",
  null
  
)

export default component.exports